import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	customerInvite: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.customer-invite',
		defaultMessage: 'Customer invitations',
		description: 'Name of the first tab',
	},
	issueFailure: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.issue-failure',
		defaultMessage: 'Request notifications',
		description: 'Name of the second tab',
	},
});
